/**
 * Slidein animation - now available as Tailwind class: animate-slidein
 *
 * Usage:
 * <div className="animate-slidein">Content</div>
 *
 * The animation is defined in styles/globals.css
 */
export const slidein = "animate-slidein";
